var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"store-locator"},[_c('div',{staticClass:"content"},[_c('StoreForm',{staticClass:"form",on:{"searchMap":_vm.searchMap}})],1),_c('div',{staticClass:"map"},[_c('StoreMap',{attrs:{"results":_vm.results}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }